









































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { Party } from '@/types';
import { FieldFlagsBag } from 'vee-validate';

@Component
export default class NewPartyModal extends Vue {
    @Prop({ default: 'New Party'}) readonly title!: string;
    @Prop({
        default: {
            name: '',
            addres: '',
            tax_number: '',
        },
    }) readonly party!: Party;

    partyData: Party = Object.assign({}, this.party);
    titleData: string = this.title;

    showModal() {
        this.partyData = Object.assign({}, this.party);
        if (this.partyData.id) {
            this.titleData = 'Edit Party';
        } else {
            this.titleData = 'New Party';
        }
        (this.$refs.modal as any).show();
    }

    saveModal() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                (this.$refs.modal as any).hide();
                this.save();
            }
        });
    }

    @Emit()
    save() {
        return this.partyData;
    }

    validateField(name: string) {
        if (this.veeFields[name] && (this.veeFields[name].dirty || this.veeFields[name].validated)) {
          return !this.errors.has(name);
        }
        return null;
    }
}
